module.exports = __webpack_public_path__ + "media/switch_tip.d46788ae.wav";